// extracted by mini-css-extract-plugin
export default {"xrayImg":"Implant_xrayImg__LOws7","content":"Implant_content__5D3F4","title":"Implant_title__o3521","text":"Implant_text__qrEem","par":"Implant_par__6esxY"};